export async function request(endpoint, method = 'GET', body = null) {
  const baseURL = process.env.REACT_APP_API_URL || '/api';
  const url = `${baseURL}${endpoint}`;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
  };

  const options = { method, headers, credentials: 'include' };
  if (body) options.body = JSON.stringify(body);

  const res = await fetch(url, options);

  if (!res.ok) {
    let message = 'Request failed';
    try {
      const data = await res.json();
      message = data.message || message;
    } catch (e) {
      // возможно, это HTML-ответ, а не JSON
      if (res.status === 404) {
        message = 'Not found';
      } else {
        message = `HTTP ${res.status}: ${res.statusText}`;
      }
    }
    
    // Добавляем информацию о статусе для отладки
    const error = new Error(message);
    error.status = res.status;
    error.url = url;
    throw error;
  }

  return res.status === 204 ? {} : res.json();
}
